<template>
  <div class="col-12 col-md-12 col-lg-7 text-center">
    <div class="tit">
      <p>Vocês possuem alguma dívida bancária?</p>
    </div>
    <div class="text-center fixedOptions">
      <button type="button" class="btn btn-lg btn-primary" @click="submitWithBankDebt">Sim</button>
      <button type="button" class="btn btn-lg btn-primary" @click="submitWithoutBankDebt">Não</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    solicitacao: {required: true, type: Object}
  },
  methods: {
    submitWithBankDebt() {
      this.$emit('on-submit', {Empresa: {TemDividaBancaria: true}})
    },
    submitWithoutBankDebt() {
      this.$emit('on-submit', {Empresa: {TemDividaBancaria: false}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/HasBankDebtStep.vue